import MUIDataTable, { MUIDataTableColumnDef, MUIDataTableOptions } from 'mui-datatables';
import { FunctionComponent } from 'react';
import { useAppTranslate } from '../../../../core/hooks';
import { StatisticsTableChartOptions } from '../../../chart-settings/components';
import { ChartSettingsInteractionModel } from '../../../chart-settings/hooks';
import { ThroughputMonitoredServiceViewModel } from '../../model';
import { BitrateStatisticsTableRow } from '../BitrateStatisticsTableRow/BitrateStatisticsTableRow';
import { formatNumberWithTwoFractionDigits } from '../../../timeseries-statistics/NumberFormatter';
import { formatThroughput } from '../../../../l3-services/model';
import { DEFAULT_LANGUAGE } from '../../../../core/config';

interface Props {
  customerId: number | null;
  monitoredServices: ThroughputMonitoredServiceViewModel[];
  chartSettingsInteraction: ChartSettingsInteractionModel;
}

const displayWithPercentSignIfDefined = (value?: number): string =>
  value === undefined ? '' : formatNumberWithTwoFractionDigits(value, DEFAULT_LANGUAGE.code, '') + '%';

export const BitrateStatisticsTable: FunctionComponent<Props> = ({
  monitoredServices,
  chartSettingsInteraction,
  customerId,
}) => {
  const translate = useAppTranslate();

  const columns: MUIDataTableColumnDef[] = [
    {
      name: 'name',
      label: translate('tableHeaders.serviceName')
    },
    {
      name: 'orderNumber',
      label: translate('tableHeaders.sozId')
    },
    {
      name: 'throughput',
      label: translate('tableHeaders.throughput'),
      options: {
        customBodyRender: (throughput?: number) => formatThroughput(throughput)
      }
    },
    {
      name: 'txBitRate',
      label: translate('tableHeaders.txBitRate'),
      options: {
        customBodyRender: (txBitRate?: number) => formatThroughput(txBitRate)
      }
    },
    {
      name: 'rxBitRate',
      label: translate('tableHeaders.rxBitRate'),
      options: {
        customBodyRender: (rxBitRate?: number) => formatThroughput(rxBitRate)
      }
    },
    {
      name: 'outgoingTrafficUtilisationPercentage',
      label: translate('tableHeaders.outgoingTraffic'),
      options: {
        customBodyRender: (outgoingTrafficUtilisationPercentage: number) => displayWithPercentSignIfDefined(outgoingTrafficUtilisationPercentage)
      }
    },
    {
      name: 'incomingTrafficUtilisationPercentage',
      label: translate('tableHeaders.incomingTraffic'),
      options: {
        customBodyRender: (incomingTrafficUtilisationPercentage: number) => displayWithPercentSignIfDefined(incomingTrafficUtilisationPercentage)
      }
    }
  ];

  const options: MUIDataTableOptions = {
    enableNestedDataAccess: '.',
    selectToolbarPlacement: 'none',
    download: false,
    print: false,
    rowHover: false,
    expandableRows: true,
    selectableRows: 'none',
    expandableRowsHeader: false,
    renderExpandableRow: (rowData, rowMeta) =>
      <BitrateStatisticsTableRow
        monitoredService={ monitoredServices[rowMeta.dataIndex] }
        columnsQuantity={ columns.length }
        chartSettings={ chartSettingsInteraction.chartSettings }
        customerId={ customerId }
      />
  };

  return <>
    <StatisticsTableChartOptions chartSettingsInteraction={chartSettingsInteraction} />
    <MUIDataTable
      title=''
      columns={ columns }
      data={ monitoredServices }
      options={ options }
    />
  </>;
};